import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Button } from 'react-bootstrap';

import { useHistory } from 'react-router-dom';

//import { Link } from "react-router-dom";

//import { user_access_level, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import { apiUrl, user_entity_uuid } from "Api/Api";
// owner_perms, org_friendly_url, user_access_level, user_account_level, organization_user_access_level,
import axios from "axios";

import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

import { get_current_unix_stamp, assembleNickname } from "utils/Helper.js";

//import './style.css';


function ChatCallButton (props) {
  const user_context = React.useContext(UserContext);
  const history = useHistory();
  
  const [allowed,setAllowed] = React.useState(false);
  const [in_call,setInCall] = React.useState(props.in_call || false);
  const [chatWindow,setChatWindow] = React.useState(null);
  const [checkChatWindow_interval,setCheckChatWindow_interval] = React.useState(null);
  
  
  const [call_in_progress_info,setCallInProgressInfo] = React.useState(null);
  
  const [buttonText,setButtonText] = React.useState('');
  const [buttonDataTip,setButtonDataTip] = React.useState('');
  
  //const [assets_array, setAssetsArray] = React.useState([]);

  // on mount / props change
  React.useEffect(() => {
    console.log("ChatCallButton useEffect",props,user_context);
    setButtonText(<i className="fa fa-video-camera" aria-hidden="true"></i>);
    setButtonDataTip('Start a video chat with '+props.entity_info.entity_name);
    setInCall(false);
    setCallInProgressInfo(null);
    
    // is this user allowed?
    if (user_context.user_info.access_level === 'admin') {
      setAllowed(true);
    }
    
    // see if we have been invited to a call with this person, or are currently in a call with this person
    if (user_context.user_info.chats) {
      Object.values(user_context.user_info.chats).forEach( (element) => {
        //console.log(" WTF",user_entity_uuid,element);
        if (element.status_code === 1) {
          if (element.shared_access_write_uuids && element.shared_access_write_uuids.includes(user_entity_uuid)) {
            // we own this chat
            // are we in a call with this user already?
            if (element.shared_access_read_uuids && element.shared_access_read_uuids.includes(props.entity_info.entity_uuid)) {
              // we already invited this user
              if (element.xref_data && element.xref_data.joined_time && !element.xref_data.left_time) {
              //if (element.users.some( element2 => (element2.entity_uuid === user_entity_uuid && element2.xref_data && element2.xref_data.joined_time && !element2.xref_data.left_time))) {
                // we are already in call with this user
                setButtonText('In Chat');
                setButtonDataTip('You are already in a chat with '+props.entity_info.entity_name);
                setInCall(true);
              } else if (element.xref_data && element.xref_data.joined_time && element.xref_data.left_time) {
              //} else if (element.users.some( element2 => (element2.entity_uuid === user_entity_uuid && element2.xref_data && element2.xref_data.joined_time && element2.xref_data.left_time))) {
                // not in call right now for some reason
                setButtonText('Rejoin Chat');
                setButtonDataTip('Rejoin this Chat');
              } else {
                // not joined call yet for some reason
                setButtonText('Join Call');
                setButtonDataTip('You have been invited to join this chat');
              }
              setCallInProgressInfo(element);
            }
          } else if (element.shared_access_read_uuids && element.shared_access_read_uuids.includes(user_entity_uuid)) {
            // invited to this chat
            if (element.shared_access_write_uuids && element.shared_access_write_uuids.includes(props.entity_info.entity_uuid)) {
              // we have already been invited by this user
              if (element.xref_data && element.xref_data.joined_time && !element.xref_data.left_time) {
              //if (element.users.some( element2 => (element2.entity_uuid === user_entity_uuid && element2.xref_data && element2.xref_data.joined_time && !element2.xref_data.left_time))) {
                // we are already in call with this user
                setButtonText('In Chat');
                setButtonDataTip('You are already in a chat with '+props.entity_info.entity_name);
                setInCall(true);
              } else if (element.xref_data && element.xref_data.joined_time && element.xref_data.left_time) {
              //} else if (element.users.some( element2 => (element2.entity_uuid === user_entity_uuid && element2.xref_data && element2.xref_data.joined_time && element2.xref_data.left_time))) {
                // not in call right now for some reason
                setButtonText('Rejoin Call');
                setButtonDataTip('Rejoin this Chat');
              } else {
                // not joined call yet for some reason
                setButtonText('Join Call');
                setButtonDataTip('You have been invited to join this chat');
              }
              setCallInProgressInfo(element);
            }
          }
        }
      })
    }
    
  }, [user_context]);
  /*
  React.useEffect(() => {
    ReactTooltip.rebuild();
  });
  */

  // on mount/unmount
  /*
  React.useEffect(() => {
    console.log("ChatCallButton useEffect MOUNT");
    return () => {
      console.log("ChatCallButton useEffect UNMOUNT");
      //clearInterval(checkChatWindow_interval);
    }
  }, []);
  */

  /*
  function checkChild() {
    console.log("checkChild",chatWindow);
    if (chatWindow && chatWindow.closed) {
      alert("Child window closed");   
      clearInterval(checkChatWindow_interval);
    }
  }
  */

  async function joinSession () {
    if (!allowed) {
      history.push(local_routes.pricing);
      return;
    }
    
    //console.log("AgoraVideoChatControlComponent joinSession");
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    window.open('/chats/'+call_in_progress_info.friendly_url, 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
  }


  async function onCall () {
    if (!allowed) {
      history.push(local_routes.pricing);
      return;
    }
    
    setInCall(true);
    
    let user_info = props.entity_info;
    if (!user_info.nickname) {
      user_info.nickname = assembleNickname(user_info);
    }
    
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    let newWindow = window.open('about:blank', 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    
    //await makeCall(user_info);
    // close modal first!
    //props.onHide();
    
    // first make new PK "chat"
    let post_obj = {
      entity_name: user_context.user_info.nickname+' - '+user_info.nickname+' Chat',
      friendly_url: user_context.user_info.nickname+'-'+user_info.nickname+'-chat',
      public_status: 'super_private',
      chat_type: 'video_chat'
    };
    let new_chat_response = await axios.post(`${apiUrl}chats`,post_obj);
    
    // need the friendly_url if it was dynamically added
    //let get_chat_response = await axios.get(`${apiUrl}chats/${new_chat_response.data.entity_uuid}`);
    
    let chat_uuid = new_chat_response.data.entity_uuid;
    //let chat_token = new_chat_response.data.openvidu_token;
    //let chat_session_id = new_chat_response.data.openvidu_session_id;
    let chat_friendly_url = new_chat_response.data.friendly_url;

    // now invite somebody to chat
    post_obj = {
      invited_time: get_current_unix_stamp(),
      entity_reader_integer: 1  
    }
    let invite_chat_response = await axios.post(`${apiUrl}chats/${chat_uuid}/users/${user_info.entity_uuid}`,post_obj);

    newWindow.location = '/chats/'+chat_friendly_url;
    
    //setChatWindow(newWindow);
    //setCheckChatWindow_interval(setInterval(checkChild, 2000));
    
    /*
    // open new tab for the actual chat
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    window.open('/chats/'+chat_friendly_url, 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    */
  }


  

  return (
    <React.Fragment>
      { (props.entity_info && user_context.user_info.entity_uuid) &&
        <Button
          disabled={in_call}
          variant="success"
          //data-tip={allowed ? (in_call ? '' : "Start a Video Call") : "* Upgrade to PK Create PRO to make Video Calls *"}
          data-tip={buttonDataTip}
          style={{ }}
          onClick={() => { call_in_progress_info ? joinSession() : onCall()}}
        >
          {buttonText}
        </Button>
      }
      <ReactTooltip />
    </React.Fragment>
  );
}

export default ChatCallButton;